var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.729 4.1665H16.2707C8.68734 4.1665 4.1665 8.68734 4.1665 16.2707V33.7082C4.1665 41.3123 8.68734 45.8332 16.2707 45.8332H33.7082C41.2915 45.8332 45.8123 41.3123 45.8123 33.729V16.2707C45.8332 8.68734 41.3123 4.1665 33.729 4.1665ZM34.9582 20.2082L23.1457 32.0207C22.854 32.3123 22.4582 32.479 22.0415 32.479C21.6248 32.479 21.229 32.3123 20.9373 32.0207L15.0415 26.1248C14.4373 25.5207 14.4373 24.5207 15.0415 23.9165C15.6457 23.3123 16.6457 23.3123 17.2498 23.9165L22.0415 28.7082L32.7498 17.9998C33.354 17.3957 34.354 17.3957 34.9582 17.9998C35.5623 18.604 35.5623 19.5832 34.9582 20.2082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.ebd4d57cab1e5976e9ff56260d1339ba.svg";
export { ForwardRef as ReactComponent };